export const PRODUCT_CATEGORIES = 
["Please Select Category", "Drinks and Berverages", "Pastry", "Fruits and Vegetables"];

export const VERSION = '1.0.17'